import axios from "axios";

const api = axios.create();

api.interceptors.request.use(
  (config) => {
    //const token = localStorage.getItem("token");
    const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3VhcmlvIjoibGVhbmRybyJ9.XprcUoRssqDYD-gFEJ1j5F60bXWaPK4fzO_56yZ4aqw"

    if (!token) {
      localStorage.clear();
      window.location.href = "/";

      return Promise.reject(
        new Error("Sin autorización")
      );
    }

    config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {

    if (error.response?.status === 401) {

      localStorage.removeItem("token");

      alert("La sesión ha expirado. Debe volver a iniciar sesión.");

      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default api;